import Axios from "axios";
import https from "https";
import { env } from "../../../env";
Axios.defaults.withCredentials = true; // enable axios post cookie, default false

export const client = Axios.create({
  httpsAgent: new https.Agent({
    rejectUnauthorized: false,
  }),
  baseURL: `${env.webservices}/api`,
  json: true,
});
